import type { oz } from '@weft/utils';
import { LineItemProductSchema } from '../../line-item-product/line-item-product-schema';
import { BaseLineItemSchema } from '../base-line-item-schema';

export const BaseProductLineItemSchema = BaseLineItemSchema.extend({
  lineItemProduct: LineItemProductSchema,
}).openapi('BaseProductLineItem');

export type BaseProductLineItem = oz.infer<typeof BaseProductLineItemSchema>;